function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M88.448 60H1.55179C0.694862 60 0 59.2929 0 58.421V1.57902C0 0.707052 0.694862 0 1.55179 0H88.4482C89.3051 0 90 0.707052 90 1.57902V58.421C89.9998 59.2931 89.305 60 88.448 60Z",
  fill: "#0052B4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M44.2104 0.000976562H41.4676L26.8419 9.58348V0.000976562H18.9471V9.58348L4.32137 0.000976562H1.57902C0.707052 0.000976562 0 0.707849 0 1.57981V2.83223L12.5483 11.0534H0V18.9481H12.5483L0 27.1695V28.4219C0 29.2938 0.707052 30.0009 1.57902 30.0009H4.32173L18.9475 20.4184V30.0009H26.8422V20.4184L41.4678 30.0009H44.2105C45.0825 30.0009 45.7896 29.2938 45.7896 28.4219V27.1695L33.2413 18.9483H45.7894V11.0536H33.2411L45.7894 2.83241V1.58C45.7894 0.707851 45.0823 0.000976562 44.2104 0.000976562Z",
  fill: "#F5F5F5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M45.7894 12.6326H25.263V0.000976562H20.5263V12.6326H0V17.3693H20.5263V30.0009H25.263V17.3693H45.7894V12.6326Z",
  fill: "#D80027"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M17.3683 11.0528L0.752484 0.26709C0.31033 0.546834 0 1.01707 0 1.57906V1.66098L14.4682 11.0528H17.3683Z",
  fill: "#D80027"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M29.7419 11.0526L45.5489 0.791835C45.2742 0.326965 44.7894 0 44.2101 0H43.8686L26.8418 11.0526H29.7419Z",
  fill: "#D80027"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0043 18.9473L0.227539 29.1883C0.499592 29.6645 0.991828 29.9999 1.57958 29.9999H1.87739L18.9046 18.9473H16.0043Z",
  fill: "#D80027"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M45.7643 28.5448L30.9782 18.9473H28.0781L44.8689 29.8464C45.3718 29.613 45.7169 29.1238 45.7643 28.5448Z",
  fill: "#D80027"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M69.7365 52.053C69.6725 52.053 69.6079 52.0328 69.553 51.9943L67.6843 50.6589L65.8153 51.9943C65.7606 52.0328 65.6958 52.053 65.6318 52.053C65.5663 52.053 65.5016 52.0328 65.4461 51.9927C65.3367 51.9126 65.2896 51.7707 65.3304 51.6412L66.0235 49.4516L64.1764 48.0886C64.0669 48.0069 64.0215 47.8666 64.0631 47.7371C64.1055 47.6077 64.225 47.5196 64.3615 47.5182L66.6583 47.4996L67.3847 45.3209C67.4279 45.193 67.5489 45.105 67.6846 45.105C67.8204 45.105 67.9415 45.1928 67.9846 45.3209L68.7109 47.4996L71.0077 47.5182C71.1442 47.5198 71.2637 47.6077 71.3061 47.7371C71.3478 47.8666 71.3022 48.0069 71.1929 48.0886L69.3457 49.4516L70.0388 51.6412C70.0796 51.7707 70.0327 51.9126 69.9231 51.9927C69.8669 52.0328 69.8015 52.053 69.7365 52.053Z",
  fill: "#D80027",
  stroke: "white",
  strokeWidth: 0.4
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M66.9194 16.5993C66.864 16.5993 66.8093 16.582 66.7623 16.549L65.1619 15.4044L63.5614 16.5492C63.5146 16.5821 63.4591 16.5994 63.4043 16.5994C63.3488 16.5994 63.2928 16.5821 63.2453 16.5478C63.1515 16.4792 63.1112 16.3577 63.1462 16.2468L63.7397 14.3717L62.1579 13.2031C62.0642 13.1331 62.0253 13.0116 62.0609 12.9021C62.0972 12.7912 62.2002 12.7159 62.3164 12.7146L64.2833 12.7001L64.9054 10.8343C64.9424 10.7248 65.046 10.6494 65.1622 10.6494C65.2785 10.6494 65.3822 10.7246 65.4191 10.8343L66.0411 12.7001L68.008 12.7146C68.1243 12.716 68.2272 12.7912 68.2635 12.9021C68.2992 13.0116 68.2602 13.1331 68.1666 13.2031L66.5847 14.3717L67.1783 16.2468C67.2132 16.3577 67.1731 16.4792 67.0792 16.5478C67.0311 16.5821 66.975 16.5993 66.9194 16.5993Z",
  fill: "#D80027",
  stroke: "white",
  strokeWidth: 0.4
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M80.972 25.4939C80.9166 25.4939 80.8619 25.4766 80.8149 25.4437L79.2147 24.2989L77.6142 25.4437C77.5673 25.4766 77.5118 25.4939 77.457 25.4939C77.4016 25.4939 77.3455 25.4766 77.298 25.4423C77.2043 25.3737 77.164 25.2522 77.1989 25.1413L77.7925 23.2662L76.2106 22.0976C76.1169 22.0276 76.078 21.9062 76.1137 21.7967C76.15 21.6858 76.2529 21.6104 76.3692 21.6092L78.3361 21.5946L78.9581 19.7288C78.9952 19.6193 79.0987 19.5439 79.215 19.5439C79.3312 19.5439 79.4349 19.6192 79.4718 19.7288L80.0939 21.5946L82.0608 21.6092C82.177 21.6106 82.28 21.6858 82.3163 21.7967C82.3519 21.9062 82.3129 22.0276 82.2193 22.0976L80.6375 23.2662L81.231 25.1413C81.266 25.2522 81.2258 25.3737 81.1319 25.4423C81.0837 25.4766 81.0276 25.4939 80.972 25.4939Z",
  fill: "#D80027",
  stroke: "white",
  strokeWidth: 0.4
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M57.6836 33.6497C57.6189 33.6497 57.555 33.6294 57.5001 33.591L55.6315 32.2542L53.7626 33.591C53.7078 33.6294 53.6431 33.6497 53.579 33.6497C53.5143 33.6497 53.4488 33.6294 53.3934 33.5894C53.2839 33.5093 53.2369 33.3674 53.2777 33.2379L53.9708 31.0483L52.1236 29.6837C52.0142 29.602 51.9687 29.4601 52.0104 29.3322C52.0528 29.2027 52.173 29.1147 52.3087 29.1133L54.6055 29.0963L55.3319 26.9176C55.3752 26.7897 55.4961 26.7017 55.6319 26.7017C55.7676 26.7017 55.8887 26.7895 55.9318 26.9176L56.6582 29.0963L58.955 29.1133C59.0908 29.1149 59.211 29.2027 59.2534 29.3322C59.295 29.4601 59.2494 29.602 59.1401 29.6837L57.293 31.0483L57.9861 33.2379C58.0269 33.3674 57.98 33.5093 57.8704 33.5894C57.814 33.6296 57.7486 33.6497 57.6836 33.6497Z",
  fill: "#D80027",
  stroke: "white",
  strokeWidth: 0.4
});

var SvgNzd = function SvgNzd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 60,
    viewBox: "0 0 90 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNzd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/NZD.599828bc.svg";
export { ForwardRef as ReactComponent };